import React from 'react';
import { Switch, Route, useRouteMatch, Redirect } from 'react-router-dom';
import i18n from 'i18next';

import {
    LoginPage,
    CreateAccountPage,
    ForgotPasswordPage,
    SetPasswordPage,
    AccountPage,
    InvitationsPage,
    NewEmployeePage,
    EmployeeDetailPage,
    OptOutPage,
} from 'pages';
import { PrivateRoute } from 'auth/components/PrivateRoute';
import { paths } from 'common/constants';
import { AppointmentTool } from 'appointment-tool';
import { getLanguagePath } from 'common/utils';

export const PageRoutes: React.FC = () => {
    const { path: lngPath } = useRouteMatch();

    return (
        <Switch>
            <Route exact path={`${lngPath}/${paths.login}`}>
                <LoginPage />
            </Route>
            <Route path={`${lngPath}/${paths.createAccount}`}>
                <CreateAccountPage />
            </Route>
            <Route path={`${lngPath}/${paths.forgotPassword}`}>
                <ForgotPasswordPage />
            </Route>
            <Route path={`${lngPath}/${paths.setPassword}`}>
                <SetPasswordPage />
            </Route>
            <Route path={`${lngPath}/${paths.appointment}`}>
                <AppointmentTool />
            </Route>
            <Route path={`${lngPath}/${paths.optOut}`}>
                <OptOutPage />
            </Route>
            <PrivateRoute path={`${lngPath}/${paths.newEmployee}`}>
                <NewEmployeePage />
            </PrivateRoute>
            <PrivateRoute exact path={`${lngPath}/${paths.employees}/:id`}>
                <EmployeeDetailPage />
            </PrivateRoute>
            <PrivateRoute path={`${lngPath}/${paths.invitations}`}>
                <InvitationsPage />
            </PrivateRoute>
            <PrivateRoute path={`${lngPath}/${paths.account}`}>
                <AccountPage />
            </PrivateRoute>
            <Route path={`${lngPath}/*`}>
                <LoginPage />
            </Route>
        </Switch>
    );
};

export const Routes: React.FC = () => (
    <Switch>
        <Route path="/:lng(nl|fr)">
            <PageRoutes />
        </Route>
        <Route
            path="*"
            render={() => {
                const fallbackLng = getLanguagePath();

                i18n.changeLanguage(fallbackLng);

                return <Redirect to={`/${fallbackLng}`} />;
            }}
        />
    </Switch>
);
